import React, { FC } from 'react';
import styled from 'styled-components';

import arrowRightIcon from '../../../icons/ic_arrow_right.svg';
import commentIcon from '../../../icons/ic_comment.svg';
import { fitbitTextBlack, fitbitGreen } from '../../../themes';
import { DeveloperContactProps } from './types';

const ContainerAnchor = styled.a`
  display: flex;
  flex-direction: row;
  border-style: ridge none none none;
  border-width: 1px;
  padding-top: 17px;
  padding-bottom: 17px;
`;

const IconImg = styled.img`
  padding-left: 16px;
`;

const InfoContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 20px;
`;

const ArrowImg = styled.img`
  margin-left: auto;
  padding-right: 15px;
`;

const DeveloperNameContainer = styled.div`
  font-size: 16px;
  line-height: 20px;
  color: ${fitbitTextBlack};
  font-weight: bold;
  letter-spacing: -0.32px;
`;

const TextContainer = styled.div`
  font-size: 16px;
  letter-spacing: -0.15px;
  color: ${fitbitGreen};
`;

interface ContactLinkProps extends DeveloperContactProps {
}

export const ContactRow: FC<ContactLinkProps> = (props) => {
  return (
    <ContainerAnchor
      id={props.id}
      href={props.href}
      target={props.target}
      onClick={props.onClick}
    >
      <IconImg src={commentIcon}></IconImg>
      <InfoContainer>
        <DeveloperNameContainer>
          {props.developerName}
        </DeveloperNameContainer>
        <TextContainer>
          {props.label}
        </TextContainer>
      </InfoContainer>
      <ArrowImg src={arrowRightIcon}></ArrowImg>
    </ContainerAnchor>
  );
};